import { Component, OnInit, Input} from "@angular/core";
import { Constant } from "../../constant";
import { EventManagerService } from "../../service/event-manager.service";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'view-image',
  templateUrl: "./view-image.html",
  styleUrls: ['./view-image.scss'],
})

export class ViewImageComponent implements OnInit  {
    @Input('documents') documents: any;
    @Input('viewCode') viewCode: any;
    photo: any = {};
    Constant = Constant;
    rotatePhoto = 1;
    constructor(
        public activeModal: NgbActiveModal,
        private eventManagerService: EventManagerService
    ) {

    }
    ngOnInit() {
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    getRotate() {
        let cla = '';
        switch (this.rotatePhoto) {
            case 1:
                cla = 'rotate0';
            break;
            case 2:
                cla = 'rotate90';
            break;
            case 3:
                cla = 'rotate180';
            break;
            case 4:
                cla = 'rotate270';
            break;
        }
        return cla;
    }
    rotatePrevious() {
        if (this.rotatePhoto > 1) {
            this.rotatePhoto--;
        }
    }
    rotateNext() {
        if (this.rotatePhoto < 4) {
            this.rotatePhoto++;
        }
    }
    download() {
        window.open(this.photo.url, '_blank');
    }
}
